import { MembersPagePluginType } from '@baserow/modules/database/membersPagePluginTypes'

import RolDeMiembro from '@extras_mg/components/RolDeMiembro'

/**
 * Cambia la celda de rol de la tabla de Miembros por una que sepa leer el rol
 * guardado.
 *
 * La del core decide el texto con `permissions === 'ADMIN' ? 'ADMIN' : 'MEMBER'`,
 * asi que con el rol Lector la columna diria "Miembro" para alguien que no lo
 * es. Es el unico sitio donde se consulta de un vistazo quien puede que.
 *
 * Se hace por este gancho —el mismo que usa enterprise para su columna de
 * roles— y no tocando el componente del core: asi una actualizacion de Baserow
 * no se lleva el cambio por delante.
 */
export class RolesMGMembersPagePluginType extends MembersPagePluginType {
  static getType() {
    return 'mg_roles_columna'
  }

  mutateMembersTableColumns(columns, context) {
    return columns.map((columna) => {
      if (columna.key !== 'permissions') {
        return columna
      }
      // Se cambia solo el componente; el resto de la columna (titulo, props,
      // orden) se deja como venga, que puede traerlo otro plugin.
      columna.cellComponent = RolDeMiembro
      return columna
    })
  }
}
